import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Calendar,
  User,
  LogOut,
  Wrench,
  Users
} from 'lucide-react';
import { useAuth } from '@shared/authContext';
import PwaUpdatePrompt from './PwaUpdatePrompt';

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: Home },
  { name: 'My Service Calls', href: '/my-service-calls', icon: Calendar },
  { name: 'View Clients', href: '/clients', icon: Users },
  { name: 'Profile', href: '/profile', icon: User }
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="flex min-h-screen flex-col">
        <header className="sticky top-0 z-20 border-b border-slate-200 bg-slate-50/95 backdrop-blur">
          <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-600 text-white shadow-sm overflow-hidden">
                <img
                  src={`${import.meta.env.BASE_URL}pwa-192.png`}
                  alt="K&R Services"
                  className="h-10 w-10"
                />
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">K&amp;R Tech</p>
                <p className="text-base font-semibold text-slate-900">Technician App</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="hidden items-center gap-2 rounded-full bg-slate-100 px-3 py-2 text-sm font-medium text-slate-600 sm:flex">
                <User className="h-4 w-4" />
                <span>{user?.firstName} {user?.lastName}</span>
              </div>
              <button onClick={logout} className="btn btn-secondary btn-sm">
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </button>
            </div>
          </div>
        </header>

        <PwaUpdatePrompt />

        <main className="flex-1 pb-24">
          <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>

        <nav className="tabbar fixed bottom-0 left-0 right-0 z-30 bg-slate-50/95">
          <div className="mx-auto flex w-full max-w-6xl items-center justify-around px-2 py-2 sm:py-3">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`tabbar-item ${isActive ? 'tabbar-item-active' : ''}`}
                >
                  <item.icon className={`tabbar-icon ${isActive ? 'text-primary-600' : ''}`} />
                  <span className="tabbar-label">{item.name}</span>
                </Link>
              );
            })}
          </div>
        </nav>
      </div>
    </div>
  );
}
